import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServiceManagment {
  apiBaseUrl = environment.apiBaseUrl;

  constructor(private _httpClient: HttpClient) {}

  get(params: { 'page[number]': number, 'page[size]': number, 'orderBy[modifiedOn]': string, 'searchFilter[name]'?: string,'filter[status]':string, }) {
    return this._httpClient.get(`${this.apiBaseUrl}/services`, { params });
  }

  AddService(data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/services`, data);
  }

  deleteService(id: string) {
    return this._httpClient.delete(`${this.apiBaseUrl}/services/${id}`);
  }

  getService(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/services${query}`);
  }

  getServiceById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/services/${id}`);
  }

  getConfig() {
    return this._httpClient.get(`${this.apiBaseUrl}/configs`);
  }

  getCategories() {
    return this._httpClient.get(`${this.apiBaseUrl}/categories`);
  }

  getInterests() {
    return this._httpClient.get(`${this.apiBaseUrl}/interests`);
  }

  getLocations(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/locations${query}`);
  }

  updateService(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/services/${id}`, data);
  }

  updateLocation(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/locations/${id}`, data);
  }

  getBooking(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/bookings${query}`);
  }

  updateBooking(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/bookings/${id}`, data);
  }

  getUserById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/users/${id}`);
  }

  getStatisticsByServiceId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  getLocationById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/locations/${id}`);
  }

  getStatisticsByLocationId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  getstatisticsDetailByCustomerId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  getStatisticsByVendorId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  getRatingByServiceId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }

  getRatingBylocationId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }

  getRatingByComboPackageId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }

  getRatingByVendorId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }


  hideReview(data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/reviews-and-ratings/hide`, data);
  }


  getServiceByLocationId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/services/location/${query}`);
  }

  toggleReviews(body: any){
    return this._httpClient.post(`${this.apiBaseUrl}/reviews-and-ratings/toggle-dummy-review`, body);
  }

}
